// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  .shipping-save-btn {
    margin-bottom: 0;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
    }
  }
  .shake {
    animation-name: shake;
    animation-duration: 1s;
    animation-fill-mode: both;
  }
  .autoComp {
    position: relative;
  }
  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70%,
    90% {
      transform: translateX(-10px);
    }
    20%,
    40%,
    60%,
    80% {
      transform: translateX(10px);
    }
  }
  .isGiftServicesChecked {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 0;
    }
  }

  .spc-card-content-fields {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy3}px`};
    line-height: 1;
    letter-spacing: 0.2px;
    color: ${(props) => props.theme.colorPalette.text.primary};

    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy4}px`};
    }
  }
  .noGiftServices {
    font-size: 14px;
    color: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
  }

  .sms-updates-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .sms-updates-wrapper {
    background-color: #f4faff;
    padding: 16px 32px;
    margin: 32px -32px -32px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 32px -16px -32px;
      padding: 16px 14px;
    }
  }

  .sms-updates-container .CheckBox__input:before {
    border-radius: 2px;
    border: 1px solid #005d95;
  }

  .sms-subscription-confirmation {
    display: flex;
    align-items: center;
  }
  .sms-updates-container .CheckBox__input:checked:before {
    background: #005d95;
    border: 1px solid #005d95;
    border-radius: 2px;
  }
`;
